import { Outlet } from '@tanstack/react-router';
import { SettingsPicker } from '@/components/common/settings';

export const SettingsLayout = () => {
  return (
    <div className="flex h-full w-full">
      <div
        className="w-64 h-full border-r border-border bg-background shrink-0 overflow-auto pr-2 p-4"
        style={{ scrollbarWidth: 'thin' }}
      >
        <SettingsPicker />
      </div>
      <div className="flex flex-col flex-1 min-w-0 h-full overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};
